import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import AxiosInterceptorSetup from './auth/config/AxiosInterceptorSetup';
import Home from './pages/Home';
import Login from './auth/pages/Login';
import Signup from './auth/pages/Signup';
import SetNewPassword from './auth/pages/SetNewPassword';
import ResetPassword from './auth/pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Plans from './pages/Plans';
import Help from './pages/Help/Help';
import Billing from './pages/Billing';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import Maintenance from './pages/Maintenance/Maintenance';
import NotFound from './pages/NotFound';
import { isMaintenance, isTestComponentAlwaysDisplay, forceAppShowApiKey } from './config/envConfig';
import LoggedInNotAllowedProtectedRoute from './auth/routes/LoggedInNotAllowedProtectedRoute';
import RoleProtectedRoute from './auth/routes/RoleProtectedRoute';
import { RoutesEnum as AppRoutes } from './routes/RoutesEnum';
import { RolesEnum as Roles } from './shared/helpers/RolesEnum';
import SetEmailVerify from './auth/pages/SetEmailVerify';
import RedirectHandler from './pages/RedirectHandler';
import AuthProvider from './auth/contexts/AuthContext';
import CampaignProvider from './contexts/CampaignContext';
import CampaignRoutes from './routes/CampaignRoutes';
import Apps from './pages/Apps';
import Test from './shared/components/Test';
import C from './pages/C';
import P from './pages/P';
import CampaignSearchByCodePage from './pages/CampaignSearchByCodePage';

const AppUser: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const checkForceAppShowApiKey = searchParams.get('forceAppShowApiKey') === forceAppShowApiKey;

  if (isMaintenance && !checkForceAppShowApiKey) {
    return (
      <Routes>
        <Route path={AppRoutes.MAINTENANCE} element={<Maintenance />} />
      </Routes>
    );
  }
  if (isTestComponentAlwaysDisplay) {
    return (
      <Routes>
        <Route path={AppRoutes.TEST} element={<Test />} />
      </Routes>
    );
  }

  return (
    <AuthProvider>
      <AxiosInterceptorSetup />
      <Routes>
        <Route path={AppRoutes.PLANS} element={<Plans />} />
        <Route path={AppRoutes.HELP} element={<Help />} />
        <Route path={AppRoutes.PRIVACY_POLICY} element={<PrivacyPolicy />} />
        <Route path={AppRoutes.TERMS} element={<Terms />} />
        <Route path={AppRoutes.REDIRECT_HANDLER} element={<RedirectHandler />} />
        <Route path={AppRoutes.SET_EMAIL_VERIFY} element={<SetEmailVerify />} />
        <Route path={AppRoutes.P} element={<P />} />

        {/*apps*/}
        <Route path={AppRoutes.APPS} element={<Apps />} />
        <Route path={AppRoutes.CAMPAIGN_SEARCH_BY_CODE} element={<CampaignSearchByCodePage />} />
        <Route element={<CampaignProvider><CampaignRoutes /></CampaignProvider>}>
          <Route element={<LoggedInNotAllowedProtectedRoute />}>
            <Route path={AppRoutes.HOME} element={<Home />} />
          </Route>
          <Route path={AppRoutes.C} element={<C />} />
        </Route>
        {/*apps - end*/}

        <Route element={<LoggedInNotAllowedProtectedRoute />}>
          <Route path={AppRoutes.RESET_PASSWORD} element={<ResetPassword />} />
          <Route path={AppRoutes.SET_NEW_PASSWORD} element={<SetNewPassword />} />
          <Route path={AppRoutes.LOGIN} element={<Login />} />
          <Route path={AppRoutes.SIGNUP} element={<Signup />} />
        </Route>

        <Route element={<RoleProtectedRoute roles={[Roles.ADMIN, Roles.USER]} />}>
          <Route path={AppRoutes.DASHBOARD} element={<Dashboard />} />
          <Route path={AppRoutes.BILLING} element={<Billing />} />
        </Route>

        <Route element={<RoleProtectedRoute roles={[Roles.ADMIN]} />}>
          
        </Route>

        <Route path={AppRoutes.NOT_FOUND} element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
};

export default AppUser;